export default class SecondsFilter {
  constructor() {
    return (seconds) => new Date(seconds * 1000).toISOString().substr(11, 8);
  }

  static filter() {
    return new SecondsFilter();
  }
}
